import { z } from "zod";

export const nameSchema = z.object({
  name: z.string().max(255, { error: "" }),
});

export type NameSchema = z.infer<typeof nameSchema>;
